// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tc-tbitem .tc-tbitem-exp { opacity:0; pointer-events:none;\n}\n.tc-tbitem:hover .tc-tbitem-exp,.tc-tbitem:focus-within .tc-tbitem-exp,.tc-tbitem.tc-tool-menu-open .tc-tbitem-exp { opacity:1; pointer-events:auto;\n}\n@media(hover:none) {\n.tc-tbitem .tc-tbitem-exp { opacity:.65; pointer-events:auto;\n}\n}\n", ""]);
// Exports
module.exports = exports;
